// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__5FD03","layout-content":"layout_layout-content__kTX70"};